import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type SettlementPayoutData = {
    settlementDetails?: any;
}

const initialState: SettlementPayoutData = {
    settlementDetails: null,
}

const settlementSlice = createSlice({
    name: 'settlementPayout',
    initialState,
    reducers: {
        setSettlementDetails: (state, action: PayloadAction<Partial<any>>) => {
            state.settlementDetails = { ...state.settlementDetails, ...action.payload };
        },
        clearSettlementDetails: (state) => {
            state.settlementDetails = null;
        },
    },
});

export const { setSettlementDetails, clearSettlementDetails } = settlementSlice.actions;

export default settlementSlice.reducer;